<template>
  <div class="left">
    <div ref="searchInput" class="searchInput">
      <el-tag
      v-for="item in selectList"
      @close="handleClose(item)"
      :key="item.id" size="medium"
      closable
      :disable-transitions="true"
      style="margin-right: 5px;">
        {{ item.name }}
      </el-tag>
      <input ref="input1" type="text" class="input1" v-model.trim="search" placeholder="搜索" v-focus />
    </div>
    <div v-if="options.length || loading" class="searchlist" :style="{maxHeight: `calc(100% - ${searchHeight}px)`}" v-loading="loading">
      <div style="padding: 10px;">您要找哪位：</div>
      <Item v-for="item in options" :key="item.id" :isHeadimg="isHeadimg" :isDown="false" :isCheckbox="false" :data="item" @onClick="handleAdd" />
      <template v-if="queryType === 'user'">
        <div v-if="!finished" class="move" @click.stop="handleMore">查看更多</div>
        <div v-else class="move">没有更多了</div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import api from './api'
import Item from './item'
export default {
  props: {
    isHeadimg: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    },
    queryType: {
      type: String,
      default: 'user'
    }
  },
  components: {
    Item
  },
  data() {
    return {
      loading: false,
      search: '',
      currentPage: 1,
      finished: false,
      options: [],
      searchHeight: 0
    }
  },
  watch: {
    search(val) {
      this.searchHeight = this.$refs.searchInput.clientHeight + 22
      switch (this.queryType) {
        case 'user':
          this.accountQuery(val)
          break
        case 'org':
          this.accountQueryOrg(val)
          break
        case 'role':
          this.accountQueryRole(val)
          break
      }
    },
    currentPage(val) {
      this.accountQuery(this.search, true)
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus()
      }
    }
  },
  methods: {
    handleClose(item) {
      this.$emit('onRemove', item)
    },
    handleAdd(item) {
      this.search = ''
      this.$refs.input1.focus()
      this.$emit('onAdd', item)
    },
    async accountQuery(name, isPage) {
      if (!isPage) {
        this.currentPage = 1
      }
      if (name !== '') {
        this.loading = true
        try {
          const { data } = await api.apiAccountQuery({ name }, 'name', {
            pageNum: this.currentPage,
            pageSize: 15,
            containOrg: true
          })
          this.loading = false
          const {
            current,
            // pages,
            records,
            size,
            total
          } = data
          if (!isPage) {
            this.options = records
          } else {
            this.options = _.unionWith(this.options, records, _.isEqual)
          }

          if (current * size >= total) {
            this.finished = true
          } else {
            this.finished = false
          }
        } catch ({ msg }) {
          this.$message.error(msg)
        }
      } else {
        this.options = []
      }
    },
    async accountQueryOrg(name) {
      if (name !== '') {
        this.loading = true
        try {
          const { data } = await api.apiOrgList({ name }, 'name')
          this.loading = false
          this.options = data
        } catch ({ msg }) {
          this.$message.error(msg)
        }
      } else {
        this.options = []
      }
    },
    async accountQueryRole(name) {
      if (name !== '') {
        this.loading = true
        try {
          const { data } = await api.apiRoleList({ name }, 'name')
          this.loading = false
          this.options = data
        } catch ({ msg }) {
          this.$message.error(msg)
        }
      } else {
        this.options = []
      }
    },
    handleMore() {
      this.currentPage += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.left {
  flex: 1;
  border-right: 1px solid #EBEEF5;
  position: relative;
  padding: 10px;
}
.move {
  text-align: center;
  font-size: 12px;
  padding: 10px;
  cursor: pointer;
}
.move:hover {
  background-color: #F5F7FA;
}
.searchInput {
  max-height: calc(100% - 70px);
  overflow: auto;
}
.searchlist {
  margin-top: 5px;
  padding: 10px 0;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);
  border-radius: 4px;
  position: relative;
  z-index: 1;
  background-color: #FFF;
  overflow: auto;
}
.input1 {
  border: 0;
  width: 100px;
  height: 27px;
  line-height: 27px;
}
</style>
